module.exports = __webpack_public_path__ + "static/kitze-1cfd64955016ed25afc6ba6e540e1718.png";